import { useEffect } from "react";
import { useActivationMutation } from "../../store/services/auth";
import { useParams, useNavigate } from "react-router-dom";
import { ROUTES } from "../../routes";
import { toastSuccess } from "../../utils/toasts";

export interface ActivationRequest {
  uid?: string;
  token?: string;
}

export const ActivationPage: React.FC = () => {
  const navigate = useNavigate();
  let { uid, token } = useParams();

  const [activation, { isSuccess, isLoading, isError }] =
    useActivationMutation();

  useEffect(() => {
    const requestActivation = async (data: ActivationRequest) =>
      await activation(data);
    requestActivation({ uid, token });
  }, [uid, token, activation]);

  useEffect(() => {
    if (isSuccess) {
      sessionStorage.removeItem("phoneNumber");
      navigate(ROUTES.AUTH_ADD_NUMBER);
      toastSuccess("Account activated");
    }

    if (isError) {
      navigate(ROUTES.AUTH_LINK_EXPIRED);
    }
  }, [isLoading, isSuccess, isError, navigate]);

  return <></>;
};
